/**
 * TradeStation and OCC option symbols.
 * TS:  AAPL 260130P247.5
 * OCC: AAPL260130P00247500
 */

function expiryFromYymmdd(yymmdd) {
  const yy = parseInt(yymmdd.slice(0, 2), 10);
  const year = yy >= 70 ? 1900 + yy : 2000 + yy;
  const month = parseInt(yymmdd.slice(2, 4), 10) - 1;
  const day = parseInt(yymmdd.slice(4, 6), 10);
  if (month < 0 || month > 11 || day < 1 || day > 31) return null;
  return new Date(Date.UTC(year, month, day));
}

function optionFromParts(underlying, yymmdd, right, strikeRaw) {
  const expiry = expiryFromYymmdd(yymmdd);
  const strike = Number(strikeRaw);
  if (!expiry || !Number.isFinite(strike)) return null;
  return { underlying, expiry, right, strike, isOption: true };
}

export function parseOptionSymbol(symbol) {
  const raw = String(symbol || '').trim().toUpperCase();
  if (!raw) return null;

  const spaced = raw.match(/^([A-Z]{1,6})\s+(\d{6})([CP])(\d+(?:\.\d+)?)$/);
  if (spaced) return optionFromParts(spaced[1], spaced[2], spaced[3], spaced[4]);

  const compact = raw.replace(/\s+/g, '');
  const occ = compact.match(/^([A-Z]{1,6})(\d{6})([CP])(\d{8})$/);
  if (occ) return optionFromParts(occ[1], occ[2], occ[3], parseInt(occ[4], 10) / 1000);

  const loose = compact.match(/^([A-Z]{1,6})(\d{6})([CP])(\d+\.\d+)$/);
  if (loose) return optionFromParts(loose[1], loose[2], loose[3], loose[4]);

  return { underlying: compact, isOption: false };
}

export function isOptionSymbol(symbol) {
  return parseOptionSymbol(symbol)?.isOption === true;
}

export function underlyingOf(symbol) {
  const parsed = parseOptionSymbol(symbol);
  if (!parsed) return '';
  return parsed.isOption ? parsed.underlying : String(symbol || '').trim().toUpperCase();
}

export function buildTsOptionSymbol(root, isoDate, right, strike) {
  const match = String(isoDate || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!match) return '';
  const cp = String(right || '').toUpperCase().startsWith('P') ? 'P' : 'C';
  const n = Number(strike);
  const strikeText = Number.isFinite(n) ? String(Math.round(n * 1000) / 1000) : String(strike);
  return `${String(root || '').trim().toUpperCase()} ${match[1].slice(2)}${match[2]}${match[3]}${cp}${strikeText}`;
}

/** One symbol form for matching stream rows to the strike list. */
export function canonicalOptionSymbol(symbol) {
  const parsed = parseOptionSymbol(symbol);
  if (!parsed?.isOption || !parsed.expiry) return String(symbol || '').trim().toUpperCase();
  const iso = parsed.expiry.toISOString().slice(0, 10);
  return buildTsOptionSymbol(parsed.underlying, iso, parsed.right, parsed.strike);
}
